import { create } from "zustand";
import type { EnvironmentId } from "@t3tools/contracts";

interface DocumentsPanelState {
  open: boolean;
  environmentId: EnvironmentId | null;
  projectCwd: string | null;
  openPanel: (input: { environmentId: EnvironmentId; projectCwd: string }) => void;
  closePanel: () => void;
}

export const useDocumentsPanelStore = create<DocumentsPanelState>((set) => ({
  open: false,
  environmentId: null,
  projectCwd: null,
  openPanel: ({ environmentId, projectCwd }) => set({ open: true, environmentId, projectCwd }),
  closePanel: () => set({ open: false }),
}));
